/* eslint-disable @typescript-eslint/no-explicit-any */
import {getStore} from '@/services/store';

export interface CitationOptions {
  pageNumbers: number[]; // The page numbers of the citation in the document.
  document: {id: string; name: string}; // The document name and ID used to retrieve the signed URL from GCS.
  deleted: boolean; // Indicates whether the citation has been deleted.
  customDeleteHandler?: (arg?: any) => void; // The callback to handle custom delete behavior.
  customRestoreHandler?: (arg?: any) => void; // The callback to handle custom restore behavior.
};

export class Citation {
  pageNumbers: number[]; // The page numbers of the citation in the document.
  document: {id: string; name: string}; // The document name and ID used to retrieve the signed URL from GCS.
  deleted: boolean; // Indicates whether the citation has been deleted.
  openCitation: () => void; // The callback to open the citation dialog.
  deleteCitation: () => void; // The callback to delete the citation.
  restoreCitation: () => void; // The callback to restore the citation.
  customDeleteHandler?: (arg?: any) => void; // The callback to handle custom delete behavior.
  customRestoreHandler?: (arg?: any) => void; // The callback to handle custom restore behavior.

  constructor({
    pageNumbers = [],
    document,
    deleted = false,
    customDeleteHandler,
    customRestoreHandler,
  }: CitationOptions) {
    this.pageNumbers = pageNumbers;
    this.document = document;
    this.deleted = deleted;

    this.customDeleteHandler = customDeleteHandler;
    this.customRestoreHandler = customRestoreHandler;

    this.openCitation = () => {
      getStore().commit('setSelectedCitation', {
        document: this.document,
        pageNumbers: this.pageNumbers,
        deleteCitation: this.deleteCitation,
        restoreCitation: this.restoreCitation,
      });
    };
    this.deleteCitation = () => {
      getStore().commit('setSelectedCitation', null);

      if (this.customDeleteHandler) {
        this.customDeleteHandler();
      }
    };
    this.restoreCitation = () => {
      if (this.customRestoreHandler) {
        this.customRestoreHandler();
      }
    };
  }
}
